import { requestWithPromise } from '..'
import { GET } from '../apiHelper'

export const getChildren = (option, user) => {
  return requestWithPromise(
    `/api/institution-options/${option.id}/children`,
    GET,
    null,
    user
  )
}
